import { collectNumbers, donchianSeries, numericExtent } from "../utils";
const DONCHIAN = {
    name: "Donchian",
    compute: (bars, period = 20) => {
        return donchianSeries(bars, period);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default DONCHIAN;
